import { gql } from '@apollo/client';

export const GET_TOP_REGIONS = gql`
  query GetTopRegions($filters: DistributionGraphsInput) {
    getTopRegions(input: $filters) {
      amountOfListings
      label
    }
  }
`;
